import { listBranch } from "../model/TblPromotion";

/** Phần tử danh mục chi nhánh trả về từ get-select-branch / getMasterOfSelect */
export interface branchMasterItem {
  value?: string | null;
  text?: string | null;
  label?: string | null;
  att2?: string | null;
}

/**
 * Đọc danh sách id chi nhánh áp dụng của chương trình khuyến mại.
 *
 * Định dạng mới BE trả về là chuỗi ",13,25," — chỉ gồm id chi nhánh. Dữ liệu cũ là
 * JSON đầy đủ object nên vẫn phải đọc được để không phải migrate DB trước khi deploy.
 */
export const parseListBranch = (
  raw: number[] | listBranch[] | string | null | undefined
): number[] => {
  if (!raw) return [];

  if (Array.isArray(raw)) {
    return raw
      .map((item) => (typeof item === "number" ? item : Number(item?.id)))
      .filter((id) => Number.isFinite(id));
  }

  const value = String(raw).trim();
  if (!value) return [];

  // Dữ liệu cũ: JSON — có thể là mảng object hoặc mảng số
  if (value.startsWith("[")) {
    try {
      const parsed = JSON.parse(value);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map((item: number | listBranch) =>
          typeof item === "number" ? item : Number(item?.id)
        )
        .filter((id: number) => Number.isFinite(id));
    } catch {
      return [];
    }
  }

  return value
    .split(",")
    .map((part) => Number(part.trim()))
    .filter((id) => Number.isFinite(id));
};

/**
 * Dựng dòng hiển thị (có mã và tên chi nhánh) từ danh sách id, tra cứu theo danh mục.
 * Id không còn trong danh mục vẫn được giữ lại để không âm thầm mất chi nhánh.
 */
export const toBranchRows = (
  ids: number[],
  master: branchMasterItem[] | null | undefined
): listBranch[] => {
  if (!ids?.length) return [];

  const dict = new Map((master ?? []).map((item) => [Number(item.value), item]));

  return ids.map((id) => {
    const found = dict.get(id);
    return {
      id,
      // att2 là mã chi nhánh; không lấy value vì đó là id
      code: found?.att2 ?? null,
      branchName: found?.text ?? found?.label ?? null,
      check: true,
    } as listBranch;
  });
};
